import React from 'react';
import classes from './FullPageLoader.module.scss';

const FullPageLoader: React.FC = () => {
  return (
      <div className={classes.overlay}>
        <div className={classes.loader}>
          <div className={classes.spinner} />
          <div className={classes.text}>Загрузка...</div>
        </div>
      </div>
  );
};

export default FullPageLoader;